import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  collections: {}, // { collectionId: { key: value } }
  requests: {}, // { requestId: { key: value } }
  folders: {}
};

const variablesSlice = createSlice({
  name: "variables",
  initialState,
  reducers: {
    setCollectionVariable: (state, action) => {
      const { collectionId, key, value } = action.payload;
      if (!state.collections[collectionId]) {
        state.collections[collectionId] = {};
      }
      state.collections[collectionId][key] = value;
    },
    setRequestVariable: (state, action) => {
      const { requestId, key, value } = action.payload;
      if (!state.requests[requestId]) {
        state.requests[requestId] = {};
      }
      state.requests[requestId][key] = value;
    },
    setFolderVariable: (state, action) => {
      const { folderId, key, value } = action.payload;
      if (!state.folders[folderId]) {
        state.folders[folderId] = {};
      }
      state.folders[folderId][key] = value;
    }
  }
});

export const { setCollectionVariable, setRequestVariable,setFolderVariable } = variablesSlice.actions;
export default variablesSlice.reducer;